export default function Privacy() {
  return (
    <div className="min-h-screen bg-white py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="font-heading font-bold text-section text-neutral-800 mb-8">
          Política de Privacidad
        </h1>

        <div className="prose prose-neutral max-w-none">
          <p className="lead text-lg text-neutral-600 mb-6">
            De conformidad con el Reglamento General de Protección de Datos (RGPD) UE 2016/679 y la
            Ley Orgánica 3/2018, de Protección de Datos Personales y garantía de los derechos
            digitales (LOPDGDD).
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            1. Responsable del Tratamiento
          </h2>
          <ul>
            <li>Identidad: [Nombre de la ONG]</li>
            <li>NIF: [XXXXXXX-X]</li>
            <li>Dirección: [Dirección completa]</li>
            <li>Email: privacy@learnleadchange.org</li>
            <li>Delegado de Protección de Datos: dpo@learnleadchange.org</li>
          </ul>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            2. Finalidades del Tratamiento
          </h2>
          <p>Tratamos tus datos personales para las siguientes finalidades:</p>
          <ul>
            <li>Gestión de cuenta de usuario y autenticación</li>
            <li>Facilitación del aprendizaje y progreso en cursos</li>
            <li>Organización y participación en campañas cívicas</li>
            <li>Envío de comunicaciones sobre nuevos cursos y campañas (con consentimiento)</li>
            <li>Estadísticas agregadas y anónimas para mejorar el servicio</li>
            <li>Cumplimiento de obligaciones legales</li>
          </ul>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">3. Base Legal</h2>
          <ul>
            <li>Consentimiento del usuario para el tratamiento de datos</li>
            <li>Interés legítimo en la mejora del servicio</li>
            <li>Cumplimiento de obligación legal (Ley de Transparencia 19/2013)</li>
          </ul>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            4. Conservación de Datos
          </h2>
          <ul>
            <li>Cuentas activas: Durante la membresía del usuario</li>
            <li>Post-baja: 3 años para cumplimiento de obligaciones legales</li>
            <li>Datos anonimizados: Indefinidamente para fines estadísticos</li>
          </ul>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            5. Derechos del Usuario (ARCO)
          </h2>
          <p>Tienes derecho a:</p>
          <ul>
            <li>Acceso: Obtener información sobre qué datos tenemos sobre ti</li>
            <li>Rectificación: Corregir datos inexactos o incompletos</li>
            <li>Cancelación: Solicitar la eliminación de tus datos</li>
            <li>Oposición: Oponerte al tratamiento de tus datos</li>
            <li>Portabilidad: Recibir tus datos en formato estructurado</li>
            <li>Limitación: Limitar el tratamiento en determinadas circunstancias</li>
          </ul>

          <p className="mt-4">
            Para ejercer estos derechos, contacta con: privacy@learnleadchange.org
          </p>
          <p>
            Plazo de respuesta: 30 días naturales desde la recepción de la solicitud.
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            6. Medidas de Seguridad
          </h2>
          <ul>
            <li>Encriptación SSL/TLS en todas las comunicaciones</li>
            <li>Autenticación segura mediante Supabase Auth</li>
            <li>Backups automáticos cifrados</li>
            <li>Auditorías de seguridad periódicas</li>
            <li>Acceso restringido a datos personales</li>
          </ul>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            7. Transferencias Internacionales
          </h2>
          <p>
            Los datos se almacenan en servidores ubicados en la Unión Europea. En caso de
            transferencias fuera de la UE, se garantiza un nivel de protección adecuado mediante
            cláusulas contractuales tipo aprobadas por la Comisión Europea.
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            8. Reclamaciones
          </h2>
          <p>
            Si consideras que no hemos tratado tus datos correctamente, puedes presentar una
            reclamación ante la Agencia Española de Protección de Datos (AEPD):
          </p>
          <ul>
            <li>Web: www.aepd.es</li>
            <li>Dirección: C/ Jorge Juan, 6, 28001 Madrid</li>
            <li>Teléfono: 901 100 099 - 912 663 517</li>
          </ul>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            9. Actualizaciones
          </h2>
          <p>
            Esta política puede actualizarse para reflejar cambios en nuestras prácticas o en la
            legislación aplicable. Última actualización: Enero 2025.
          </p>
        </div>
      </div>
    </div>
  )
}
